import { c as _c } from "react/compiler-runtime";
import { RechartsArea as Area, type RechartsAreaProps as AreaProps } from '@precis-digital/kurama/recharts';
import type { ReactElement } from 'react';
const GradientLine = t0 => {
  const $ = _c(7);
  let dataKey;
  let props;
  if ($[0] !== t0) {
    ({
      dataKey,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = dataKey;
    $[2] = props;
  } else {
    dataKey = $[1];
    props = $[2];
  }
  const t1 = dataKey as string;
  const t2 = `url(#lineGradient-${dataKey as string})`;
  let t3;
  if ($[3] !== props || $[4] !== t1 || $[5] !== t2) {
    t3 = <Area type="monotoneX" {...props} dataKey={t1} fill={t2} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default GradientLine;